import { AssetQueryData, AssetSource } from '@cesdk/engine'

import {
  fetchLooks,
  lookQueryKeys,
} from '../../../hooks/shopwith/looks/queries'

async function findAssetsAssets(queryData: AssetQueryData) {
  // ignore searching
  if (queryData.query) return

  const response = await fetchLooks({
    meta: undefined,
    queryKey: lookQueryKeys.list(),
    pageParam: queryData.page,
  })

  return {
    assets: response.data.map((d) => ({
      id: d.objectId,
      meta: {
        uri: d.cloudinary?.data?.secure_url,
        thumbUri: d.cloudinary?.data?.secure_url,
      },
    })),
    total: response.totalCount,
    currentPage: queryData.page,
    nextPage: response.hasNextPage ? queryData.page + 1 : undefined,
  }
}

const assetsAssetLibrary: AssetSource = {
  id: 'assets-assets',
  findAssets: findAssetsAssets,
}

export { assetsAssetLibrary }
